


























import { mapGetters, mapActions } from 'vuex'
import AdminNavbar from '@/components/AdminNavbar.vue'
import BankModal from '@/components/BankModal.vue'

export default {
  name: 'AdminBanks',
  components: {
    AdminNavbar,
    BankModal
  },
  data () {
    return {
      newBankForm: {
        name: ""
      }
    }
  },
  computed: {
    ...mapGetters([
      'bankList'
    ])
  },
  methods: {
    ...mapActions([
      'getBankList',
    ]),

    navTo (path: string) {
      this.$router.push(path)
    },

    newBank () {
      this.$refs.bankModal.show()
    },

    editBank (bank: Bank) {
      this.$refs.bankModal.show(bank)
    },

  },
  mounted () {
    this.$store.commit('clearCurrentBank')
    this.getBankList()
  }
}
